import api from "./API";

/**
 * Item Issue Service
 * API service for managing item issuance to departments (formerly sales)
 */

export  const itemIssueService = {
  /**
   * Get all item issues with optional filters and pagination
   * @param {Object} params - Query parameters (page, limit, department, status, purpose, etc.)
   * @returns {Promise} API response with item issues list
   */
  getItemIssues: (params) => api.get("/item-issues", { params }),

  /**
   * Get a single item issue by ID
   * @param {string} id - Item issue ID
   * @returns {Promise} API response with item issue details
   */
  getItemIssue: (id) => api.get(`/item-issues/${id}`),

  /**
   * Create a new item issue (draft status)
   * @param {Object} data - Item issue data
   * @returns {Promise} API response with created item issue
   */
  createItemIssue: (data) => api.post("/item-issues", data),

  submitItemIssue: (id, data) => api.put(`/item-issues/${id}/submit`, data),


  /**
   * Approve an item issue and allocate stock
   * @param {string} id - Item issue ID
   * @param {Object} data - Approval data (approvedBy, notes, etc.)
   * @returns {Promise} API response with approved item issue
   */
  approveItemIssue: (id, data = {}) => api.put(`/item-issues/${id}/approve`, data),

  /**
   * Mark item issue as issued (items physically distributed)
   * @param {string} id - Item issue ID
   * @param {Object} data - Issue data
   * @returns {Promise} API response with updated item issue
   */
  issueItems: (id, data = {}) => api.put(`/item-issues/${id}/issue`, data),

  /**
   * Cancel an item issue and restore stock
   * @param {string} id - Item issue ID
   * @param {Object} data - Cancellation reason
   * @returns {Promise} API response
   */
  cancelItemIssue: (id, data = {}) => api.put(`/item-issues/${id}/cancel`, data),

  /**
   * Check stock availability for requested items
   * @param {Object} data - Items to check (array of {item, quantity})
   * @returns {Promise} API response with availability status
   */
  checkAvailability: (data) => api.post("/item-issues/check-availability", data),

  /**
   * Get returnable items from a specific item issue
   * @param {string} id - Item issue ID
   * @returns {Promise} API response with returnable items
   */
  getReturnableItems: (id) => api.get(`/item-issues/${id}/returnable`),

  /**
   * Update an item issue (for draft status only)
   * @param {string} id - Item issue ID
   * @param {Object} data - Updated item issue data
   * @returns {Promise} API response with updated item issue
   */
  updateItemIssue: (id, data) => api.put(`/item-issues/${id}`, data),

  /**
   * Get item issue by ID (alias for getItemIssue)
   * @param {string} id - Item issue ID
   * @returns {Promise} API response with item issue details
   */
  get: (id) => api.get(`/item-issues/${id}`),
};

export default itemIssueService;
